<template>
    <div class="product-page">
        <div class="main-container header-section">
            <div class="header-top">
                <h1 class="brand-title">ADDRESS MANAGEMENT</h1>
            </div>
            <div class="filter-bar">
                <button class="checkout-btn" @click="handleAddNew({}, 0)" style="width: 140px;">ADD NEW</button>
            </div>
        </div>
        <Address :visible="visible" @closeHandler="handleClose" :EditData="EditData" />
        <div class="main-container content-section"
            v-show="total > 0 && tableData && tableData.length > 0 && screenWidth > 768">
            <el-row class="tab_head">
                <el-col v-for="item in headList" :key="item.name" :xs="item.minNum" :sm="item.maxNum">
                    <div class="tab_item">{{ item.name }}</div>
                </el-col>
            </el-row>
            <el-row class="tab_content" v-for="(item, index) in tableData" :key="index">
                <el-col :xs="4" :sm="3">
                    {{ item.firstName }} {{ item.lastName }}
                </el-col>
                <el-col :xs="4" :sm="3">
                    {{ item.phone }}
                </el-col>
                <el-col :xs="6" :sm="9" class="address-col">
                    {{ item.address ? item.address + ',' : '' }} {{ item.apt ? item.apt + ',' : '' }}{{ item.city ?
                        item.city + ',' : '' }} {{ item.state ? item.state + ',' : '' }} {{ item.country }}
                </el-col>
                <el-col :xs="4" :sm="3">
                    {{ item.postCode }}
                </el-col>
                <el-col :xs="4" :sm="3">
                    <el-checkbox v-model="item.defaultFlag" true-label="1" false-label="0"
                        @change="handleDefaultChange(item)"></el-checkbox>
                    <span style="margin-left: 10px;">{{ item.defaultFlag == '1' ? 'Default address' : 'Set as default'
                        }}</span>
                </el-col>
                <el-col :xs="4" :sm="3" class="operation-col">
                    <div @click="handleAddNew(item, 1)"> EDIT</div>
                    <div style="margin-left: 20px;" @click="handleDelete(item)"> DELETE</div>
                </el-col>
            </el-row>
        </div>
        <div class="main-container content-section"
            v-show="total > 0 && tableData && tableData.length > 0 && screenWidth <= 768">
            <div class="tab_main" v-for="(item, index) in tableData" :key="index">
                <div class="tab_item">
                    <strong style="color: #000;font-size: 4.5rem;"> {{ item.firstName }} {{ item.lastName }}</strong>
                </div>
                <div class="tab_item">
                    {{ item.phone }}
                </div>
                <div class="tab_item">
                    {{ item.address ? item.address + ',' : '' }} {{ item.apt ? item.apt + ',' : '' }}{{ item.city ?
                        item.city + ',' : '' }} {{ item.state ? item.state + ',' : '' }} {{ item.country }}
                </div>
                <div class="tab_item">
                    {{ item.postCode }}
                </div>
                <div class="tab_item">
                    <div>
                        <el-checkbox v-model="item.defaultFlag" true-label="1" false-label="0"
                            @change="handleDefaultChange(item)"></el-checkbox>
                        <span style="margin-left: 10px;">{{ item.defaultFlag == '1' ? 'Default address' : 'Set asdefault'}}</span>
                    </div>
                    <div style="display: flex;">
                        <div @click="handleAddNew(item, 1)"> EDIT</div>
                        <div style="margin-left: 20px;" @click="handleDelete(item)"> DELETE</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="pagination-section" v-show="total > 0 && tableData && tableData.length > 0">
            <el-pagination layout="prev, pager, next, slot" :total="total" :current-page.sync="pageNo"
                prev-text="< Previous" next-text="Next >" @current-change="getAddressList">
            </el-pagination>
        </div>
    </div>
</template>


<script>
import '@/style/address.scss'
import { userAddressPojoList, addressDelete, defaultFlagUpdate } from '@/api/member'
import Address from '@/components/address.vue'
import { mapGetters } from "vuex";
export default {
    components: {
        Address
    },
    data() {
        return {
            visible: false,
            headList: [
                { name: 'Consignee', maxNum: 3, minNum: 3 },
                { name: 'Telephone', maxNum: 3, minNum: 3 },
                { name: 'Specific Address', maxNum: 9, minNum: 9 },
                { name: 'Postal Code', maxNum: 3, minNum: 3 },
                { name: 'Mobile Settings', maxNum: 3, minNum: 3 },
                { name: 'Operation', maxNum: 3, minNum: 3 }],
            tableData: [],
            pageNo: 1,
            total: 0,
            EditData: {},
        };
    },
    activated() {
        this.getAddressList(1);
    },
    computed: {
        ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;
        },
    },
    methods: {
        handleDefaultChange(item) {
            defaultFlagUpdate({
                wdId: item.wdId,
                defaultFlag: item.defaultFlag
            }).then(res => {
                if (res.code == 1) {
                    this.getAddressList(this.pageNo);
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            })

        },
        handleClose(data = {}) {
            this.visible = false
            console.log(data);
            if (data.type != 0) {
                this.getAddressList(1);
            }
        },
        async getAddressList(pageNo) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.8)'
            });
            this.pageNo = pageNo ? pageNo : this.pageNo
            const res = await userAddressPojoList({
                pageNo: this.pageNo,
            })

            if (res.code == 1) {
                res.data.dataList.forEach(item => {
                    item.defaultFlag = item.defaultFlag == 1 ? '1' : '0'
                })
                this.tableData = res.data.dataList
                this.total = res.data.count
                if (this.pageNo > 1 && this.tableData.length === 0) {
                    this.pageNo--;
                    this.getAddressList(this.pageNo);
                }
            }
            setTimeout(() => {
                loading.close();
            }, 500);
        },
        handleAddNew(data = {}, type = 0) {
            this.visible = true
            this.EditData = type == 0 ? {} : JSON.stringify(data)
        },
        handleDelete(data) {
            this.$confirm('Are you sure you want to delete this address?', 'Delete Address', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'ExitConfirmButton',
                cancelButtonClass: 'ExitCancelButton',
                type: 'warning'
            }).then(() => {
                addressDelete({
                    wdId: data.wdId
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message: 'Address deleted successfully',
                            type: 'success'
                        });
                        this.getAddressList(this.pageNo);
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            });
        }
    }
};
</script>


<style>
.el-checkbox__input.is-focus .el-checkbox_inner,
.el-checkbox__inner:hover {
    border: 1px solid #5D4E46;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #5D4E46;
    border: 1px solid #5D4E46;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #5D4E46 !important;
}

</style>
<style lang="scss" scoped>
.pagination-section {
    text-align: center;
    margin-top: 60px;

    ::v-deep .el-pagination {
        font-family: $serif-font;
        font-weight: normal;

        .btn-prev,
        .btn-next {
            background-color: transparent;
            color: #666;
            height: 32px;

            span {
                font-size: 14px;
            }
        }

        .el-pager li {
            background-color: transparent;
            color: #999;
            font-weight: normal;
            font-size: 14px;
            height: 32px;
            line-height: 32px;

            &.active {
                color: #000;
                font-weight: bold;
            }

            &:hover {
                color: #000;
            }
        }
    }
}

</style>